export const blankBeneficiary = {
  firstName: '',
  lastName: '',
  tin: '',
  percentOfAllocation: '',
};
